import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import {
	BreadcrumbsPropType,
	MetaPropType,
	NavigationPropType,
	PaginationPropType,
	PromoBlockPropType,
	RubricPropType
} from 'propTypes/common';

import Breadcrumbs from 'components/Breadcrumbs';
import Container from 'components/Container';
import { Layout, LayoutBlock } from 'components/Layout';
import SimilarPersons from 'components/sections/SimilarPersons';

import PushkinDayPromoBlock from 'components/promoBlocks/PushkinDayPromoBlock';
import AboutAuthor from './components/AboutAuthor';
import Catalog from './components/Catalog';
import Heading from './components/Heading';
import Publications from './components/Publications';

import styles from './styles.module.scss';

const PoemsTemplate = ({
	menu,
	pagination,
	urlParams,
	publications,
	persons,
	author,
	rubric,
	breadcrumbs,
	poems,
	meta,
	filters,
	topPromoBlock,
	pushkinDayPromoBlock
}) => {
	const { asPath } = useRouter();

	const isPushkin = author?.name === 'aleksandr-pushkin';

	return (
		<Layout
			menu={menu}
			rubric={rubric}
			meta={meta}
			topPromoBlock={topPromoBlock}
		>
			<div className={styles.PoemsHead}>
				<Container>
					<Breadcrumbs items={breadcrumbs} currentPath={asPath} />
					{author && author.status === 'published' ? (
						<AboutAuthor entity={author} mainTitle={meta.headingTitle} />
					) : (
						<Heading
							title={meta.headingTitle}
							thumbnailFile={author?.thumbnailFile}
						/>
					)}
				</Container>
			</div>
			<div className={styles.PoemsPublications}>
				<Container width="wideSlider">
					<Publications entities={publications} />
				</Container>
			</div>
			<LayoutBlock>
				<Container>
					<Catalog
						poems={poems}
						pagination={pagination}
						urlParams={urlParams}
						path={rubric.path}
						filters={filters}
					/>
				</Container>
			</LayoutBlock>

			{!_.isEmpty(pushkinDayPromoBlock) && (isPushkin || _.isEmpty(author)) && (
				<LayoutBlock gutter="medium">
					<Container>
						<PushkinDayPromoBlock promoBlock={pushkinDayPromoBlock} />
					</Container>
				</LayoutBlock>
			)}

			{!_(persons).isEmpty() && (
				<SimilarPersons
					entities={persons}
					title="Биографии"
					url="/literature/persons/poet"
				/>
			)}
		</Layout>
	);
};

PoemsTemplate.propTypes = {
	menu: NavigationPropType.isRequired,
	urlParams: PropTypes.object.isRequired,
	pagination: PaginationPropType.isRequired,
	publications: PropTypes.array.isRequired,
	persons: PropTypes.array.isRequired,
	author: PropTypes.object,
	rubric: RubricPropType.isRequired,
	breadcrumbs: BreadcrumbsPropType.isRequired,
	poems: PropTypes.array.isRequired,
	meta: MetaPropType.isRequired,
	filters: PropTypes.shape({
		tags: PropTypes.array
	}),
	topPromoBlock: PromoBlockPropType,
	pushkinDayPromoBlock: PromoBlockPropType
};

export default PoemsTemplate;
